export * from "./types.js";
export * from "./copy.js";
export {
  calculateIncomeTax,
  taxOnSchedule,
  bracketsFor,
  residentTaxFreeThreshold,
  incomeTaxFor,
  medicareLevyFor,
  litoFor,
  saptoFor,
  helpRepaymentFor,
} from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";
export { fy2026_27 } from "./fy2026-27.js";

import type { FinancialYear } from "../types.js";
import type { IncomeTaxRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";
import { fy2026_27 } from "./fy2026-27.js";

/** Registry of income-tax rulesets by financial year. Historical years stay
 * registered so re-runs/amendments resolve against the right rules. */
export const INCOME_TAX_RULESETS: Record<string, IncomeTaxRuleSet> = {
  "2025-26": fy2025_26,
  "2026-27": fy2026_27,
};

/** Resolve the income-tax ruleset for a financial year, or throw if unknown. */
export function incomeTaxRulesFor(fy: FinancialYear): IncomeTaxRuleSet {
  const rules = INCOME_TAX_RULESETS[fy];
  if (!rules) {
    throw new Error(`no income-tax ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent income-tax ruleset — the default for live "this year" calcs. */
export const INCOME_TAX_CURRENT_FY: FinancialYear = "2025-26";
